import { useQuery } from '@apollo/client'
import * as SettingsCell from './SettingsCell'
import { gql } from '@apollo/client'

export { gql }

const Cell = (props) => {
  const { QUERY, beforeQuery, Loading, Empty, Failure, Success } = SettingsCell

  if (!QUERY) {
    return null
  }

  const queryOptions = beforeQuery ? beforeQuery(props) : { variables: props }
  const { data, loading, error } = useQuery(QUERY, {
    ...queryOptions,
    fetchPolicy: queryOptions.fetchPolicy || 'cache-first',
  })

  if (loading) {
    return Loading ? <Loading /> : <div>Loading...</div>
  }

  if (error) {
    return Failure ? <Failure error={error} /> : <div>Error: {error.message}</div>
  }

  if (!data || Object.keys(data).length === 0) {
    return Empty ? <Empty {...props} /> : null
  }

  const dataKey = Object.keys(data)[0]
  const cellData = data[dataKey]

  return <Success {...props} {...{ [dataKey]: cellData }} />
}

export default Cell
